import PropTypes from "prop-types";
import React from "react";

import Icon from "../../components/interface/Icon";
import {
  getFlashComponents,
  getIconComponents,
  getLinkComponents,
  splitTextAtIconsAndLinks
} from "../../tutorial/utils";
import uniqueId from "../../utils/uniqueId";

const EXIT_EDIT_MODE_STEP_TEXT = "Tap on Done in the toolbar to exit Edit Mode.";

const renderStepTextWithIconsAndLinks = (text, className, onLinkClick, onFlashClick) => {
  const components = splitTextAtIconsAndLinks(text).map((t, i) => {
    const iconData = getIconComponents(t);
    if (iconData) {
      const { icon, color } = iconData;
      return <Icon key={i} icon={icon} color={color} />;
    }
    const linkData = getLinkComponents(t);
    if (linkData) {
      const { id, text } = linkData;
      return (
        <span key={i} className={`${className} tipEmbeddedExternalLink`} onClick={() => onLinkClick(id)}>
          {text}
        </span>
      );
    }
    const flashData = getFlashComponents(t);
    if (flashData) {
      const { id, text } = flashData;
      return (
        <span key={i} className={`${className} tipEmbeddedFlashLink`} onClick={() => onFlashClick(id)}>
          {text}
        </span>
      );
    }
    return (
      <span key={i} className={className}>
        {t}
      </span>
    );
  });

  return <span className="tipContent">{components}</span>;
};

const TutorialTipStepsView = props => {
  let stepCount = 1;
  let steps = props.tip.steps.map((step, i) => {
    let bullet = <Icon icon="statusOpen2" color="iconMono" />;
    if (step.isNumbered) {
      bullet = (
        <span className="tipStepNumber" key={uniqueId()}>
          {stepCount}.
        </span>
      );
      stepCount += 1;
    }
    return (
      <div className="tipStep" key={i}>
        {bullet}
        {renderStepTextWithIconsAndLinks(
          props.replaceTextCallback(step.label),
          props.className,
          props.onLinkClick,
          props.onFlashClick
        )}
      </div>
    );
  });
  if (props.isEditMode) {
    const editModeStep = (
      <div className="tipStep" key="editModeStep">
        <Icon icon="statusOpen2" color="iconMono" />
        {renderStepTextWithIconsAndLinks(
          EXIT_EDIT_MODE_STEP_TEXT,
          props.className,
          props.onLinkClick,
          props.onFlashClick
        )}
      </div>
    );
    steps = steps.unshift(editModeStep);
  }

  return <React.Fragment>{steps}</React.Fragment>;
};

TutorialTipStepsView.propTypes = {
  tip: PropTypes.object.isRequired,
  className: PropTypes.string,
  isEditMode: PropTypes.bool,
  onLinkClick: PropTypes.func,
  onFlashClick: PropTypes.func,
  replaceTextCallback: PropTypes.func
};

export default TutorialTipStepsView;
